import { Call, CallUpdates } from 'app/models/dto/call.model';
import { Queue } from 'app/models/queue/queue.model';

export class InitiateCall {
  static readonly type = '[Call] Initiated';
  constructor(public call: Call) {}
}

export class InitiateSecondCall {
  static readonly type = '[Call] InitiateSecondCall';
  constructor(public callInfo: object) {}
}

export class TransferCall {
  static readonly type = '[Call] TransferCall';
  constructor(public callInfo: object) {}
}

export class SwapCalls {
  static readonly type = '[Call] SwapCalls';
  constructor() {}
}

export class MergeCalls {
  static readonly type = '[Call] MergeCalls';
  constructor() {}
}

export class CancelCall {
  static readonly type = '[Call] CancelCall';
  constructor() {}
}


export class StartRingTone {
  static readonly type = '[Call] StartRingTone';
  constructor() {}
}


export class EndRingTone {
  static readonly type = '[Call] EndRingTone';
  constructor() {}
}


export class LoadUnendedCall {
  static readonly type = '[Call] LoadUnendedCall';
  constructor(public callId: number) {}
}

export class ConnectIncomingQueueCall {
  static readonly type = '[Call] ConnectIncomingQueueCall';
  constructor(public callId: number) {}
}

export class UpdateUnknownCall {
  static readonly type = '[Call] UpdateUnknownCall';
  constructor(public borrowerId: number) {}
}

export class DismissQueueCall {
  static readonly type = '[Call] DismissQueueCall';
  constructor(public callId: number, public updates: CallUpdates) {}
}

export class ConnectIncomingCall {
  static readonly type = '[Call] ConnectIncomingCall';
  constructor(public callId: number, public connectSoftPhone: boolean) {}
}

export class DismissCall {
  static readonly type = '[Call] DismissCall';
  constructor(public callId: number, public updates: CallUpdates) {}
}

export class UpdateCall {
  static readonly type = '[Call] UpdateCall';
  constructor(public updates: CallUpdates) {}
}

export class DisconnectCall {
  static readonly type = '[Call] DisconnectCall';
  constructor(public callId: number) {}
}

export class GetCurrentCallState {
  static readonly type = '[Call] GetCurrentCallState';
  constructor(public passedState: string) {}
}

export class MutateCallState {
  static readonly type = '[Call] MutateCallState';
  constructor(public state: string, public callData: any) {}
}

export class QueueCall {
  static readonly type = '[Call] QueueCall';
  constructor(public queuedCall: Queue) {}
}

export class ClearActiveCall {
  static readonly type = '[Call] ClearActiveCall';
  constructor() {}
}

export class HoldCall {
  static readonly type = '[Call] HoldCall';
  constructor(public callId: number) {}
}

export class UnHoldCall {
  static readonly type = '[Call] UnHoldCall';
  constructor(public callId: number) {}
}

export class MuteState {
  static readonly type = '[Call] MuteState';
  constructor(public setting: boolean | null) {}
}

export class DismissCallAlert {
  static readonly type = '[Alert] DismissCallAlert';
  constructor(public alertIndex: number) {}
}

export class HandleCallTimers {
  static readonly type = '[Call] HandleCallTimers';
  constructor() {}
}

export class SilentMonitor {
  static readonly type = '[Call] SilentMonitor';
  constructor(public callId: number) {}
}

export class ToggleSilentMonitorMuteState {
  static readonly type = '[Call] ToggleSilentMonitorMuteState';
  constructor(public muteState: boolean) {}
}

export class SilentMonitorInProgress {
  static readonly type = '[Call] SilentMonitorInProgress';
  constructor(public active: boolean) {}
}

export class PushCallAlert {
  static readonly type = '[Alert] PushCallAlert';
  constructor(public alertLevel: any, public message: string) {}
}
